import commonLogoFull from '~/assets/images/logo_elearning_full.png';
import commonLogoFullPositive from '~/assets/images/logo_elearning_full_positive.png';

const images = {
  commonLogoFull,
  commonLogoFullPositive,
};

export default images;
